"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Ticket_1 = require("@dialogexe/cw-component-ticket/Ticket");
const images_1 = require("@dialogexe/cw-asset-provider/images");
const RATING_AGE_LIMIT = "rating_age_limit";
class ProgramItem extends React.Component {
    constructor() {
        super(...arguments);
        this.visibleTickets = 6;
        this.defaultUIMood = "mobile";
        this.getEventDetails = (title, subtitle, link, uiType) => {
            const dynamicClass = uiType && uiType === this.defaultUIMood
                ? "event-details  is-hidden-tablet is-hidden-desktop" : "event-details is-hidden-mobile";
            return (React.createElement("div", { className: dynamicClass },
                React.createElement("a", { href: link },
                    React.createElement("h2", null, title)),
                this.hasPropertiesSet() && (React.createElement("div", { className: "event-properties" },
                    React.createElement("span", null, this.getPropertyValue('rating_age_limit')),
                    React.createElement("span", { className: "is-hidden-mobile" }, this.getPropertyValue('genre') && ` | ${this.getPropertyValue('genre')}`),
                    React.createElement("span", null, this.getPropertyValue('length') && ` | ${this.getPropertyValue('length', true)}`))),
                subtitle && (React.createElement("p", { className: "movie-subtitle" }, subtitle))));
        };
        this.filterFeaturesByProperty = (features) => {
            const { properties } = this.props;
            const propertyItem = properties.find(item => item.property === RATING_AGE_LIMIT);
            if (propertyItem) {
                return features.filter(feature => feature.name.toUpperCase() !== propertyItem.value.toUpperCase());
            }
            return features;
        };
    }
    render() {
        const { image, title, subtitle, description, cast, features, tickets, link, club, preferredLanguage } = this.props;
        return (React.createElement("div", { className: "event" },
            React.createElement("div", { className: "event-container" },
                React.createElement("div", { style: { display: 'flex' } },
                    React.createElement("a", { href: link, className: "event-poster", style: { backgroundImage: `url("${image}")` } }),
                    this.getEventDetails(title, subtitle, link, "mobile")),
                React.createElement("div", { className: "event-data" },
                    this.getEventDetails(title, subtitle, link, "desktop"),
                    React.createElement("div", { className: "row is-spaced" }, tickets.slice(0, this.visibleTickets).map((ticket, index) => (React.createElement("div", { key: index, className: "column is-lg-4 is-md-6 is-xs-12" },
                        React.createElement(Ticket_1.Ticket, { date: ticket.date, title: ticket.location, features: this.filterFeaturesByProperty(ticket.features), link: ticket.purchaseUrl ? ticket.purchaseUrl : ticket.link, showFullDate: this.props.showFullDate, ticketDisplayMode: this.props.ticketDisplayMode, count: ticket.count, countLow: ticket.countLow, salesEnabled: ticket.salesEnabled, salesActive: ticket.salesActive, ticketSaleWebEndDate: ticket.ticketSaleWebEndDate, adFlags: ticket.adFlags, adFlagsView: ticket.adFlagsView, preferredLanguage: preferredLanguage, ticketSaleType: ticket.ticketSaleType, ticketSaleWebStartDate: ticket.ticketSaleWebStartDateRealTime ? ticket.ticketSaleWebStartDateRealTime : ticket.ticketSaleWebStartDate, highlightHeading: ticket.highlightHeading, highlightBody: ticket.highlightBody }))))),
                    React.createElement("div", { className: "row" }, tickets.length > this.visibleTickets &&
                        React.createElement("div", { className: "more-link-wrapper" },
                            React.createElement("div", { className: "column" },
                                React.createElement("a", { href: link, className: "event-link" }, `+ ${tickets.length - this.visibleTickets} flere arrangement`)))))),
            club && preferredLanguage == "nn" ?
                React.createElement("div", { className: "club-stripe" },
                    React.createElement("div", { className: "expanded" },
                        React.createElement("span", { className: "hidden-mobile" }, "Denne filmen kan du sj\u00E5 p\u00E5 kino til 50% for"),
                        React.createElement("span", null,
                            React.createElement("img", { src: images_1.kinoklubbBlackImage, alt: "kinoklubb" })),
                        React.createElement("span", { className: "hidden-mobile" }, "-medlemar")),
                    React.createElement("div", null,
                        React.createElement("a", { className: "btn text-link link-decor", href: "https://www.kinoklubb.no", target: "_blank" }, "Les meir")))
                : club &&
                    React.createElement("div", { className: "club-stripe" },
                        React.createElement("div", { className: "expanded" },
                            React.createElement("span", { className: "hidden-mobile" }, "Denne filmen kan sees p\u00E5 kino til 50% for"),
                            React.createElement("span", null,
                                React.createElement("img", { src: images_1.kinoklubbBlackImage, alt: "kinoklubb" })),
                            React.createElement("span", { className: "hidden-mobile" }, "-medlemmer")),
                        React.createElement("div", null,
                            React.createElement("a", { className: "btn text-link link-decor", href: "https://www.kinoklubb.no", target: "_blank" }, "Les mer")))));
    }
    getPropertyValue(id, flag = false) {
        const { properties } = this.props;
        const property = properties.find(item => item.property === id);
        if (flag) {
            return property ? this.convertLengthFormat(property.value) : '';
        }
        return property ? property.value : '';
    }
    hasPropertiesSet() {
        const { properties } = this.props;
        return Array.isArray(properties) && properties.length > 0;
    }
    substring(text, length) {
        return (typeof text === 'string' && text.length > length) ? `${text.substring(0, length)}...` : text;
    }
    convertLengthFormat(length) {
        const minutes = Number(length);
        if (isNaN(minutes)) {
            return length;
        }
        return Math.floor(minutes / 60) + 't ' + minutes % 60 + 'min';
    }
}
exports.ProgramItem = ProgramItem;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-program/ProgramItem.tsx